export default __webpack_public_path__ + "static/media/arrow-circle.a03ebdb2.svg";